import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { ColumnTypeEnum } from '@y42/json-schema';
import { combineLatest, map, Observable } from 'rxjs';
import { ColumnTypesStateService } from '../column-types-state.service';

@UntilDestroy()
@Component({
  selector: 'y42-column-type-icon',
  templateUrl: './column-type-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnTypeIconComponent {
  constructor(private readonly columnTypesStateService: ColumnTypesStateService) {}

  @Input()
  @InputObservable()
  type!: ColumnTypeEnum;
  type$!: Observable<ColumnTypeEnum | undefined>;

  readonly ColumnTypeEnum = ColumnTypeEnum;
  readonly state = connectState(this, {
    columnDataType: combineLatest([this.type$, this.columnTypesStateService.select((s) => s.entityState)]).pipe(
      map(([type, __]) => (type ? this.columnTypesStateService.getTypeById(type) : null)),
    ),
  });
}
